export const gtmPlugin = (store) => {
  if (typeof window === 'undefined') return; // SSR guard if needed

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  // When the app boots, update consent from your stored state
  // (HTML already set a very strict 'denied' default)
  const currentConsent = store.getters['consent/consentData'];
  gtag('consent', 'update', currentConsent);

  // Listen for consent changes
  store.subscribe((mutation) => {
    if (mutation.type === 'consent/setHasConsent' || mutation.type === 'consent/setConsentData') {
      const consent = store.getters['consent/consentData'];
      gtag('consent', 'update', consent);
    }
  });
};
